module.exports = __webpack_public_path__ + "img/creative_thumbnail.d79a2e57.jpg";